import { mixpanelClient } from "@/lib/mixpanel";

export const useMixpanelClient = () => mixpanelClient;
